// ─── Contrôle d'accès par membre (Core) ───────────────────────────
// « Qui voit quoi » dans un espace. Convention, valable partout :
//   • `lecteurs` ABSENT (null/undefined)  → tout le monde (défaut, rétro-compat)
//   • `lecteurs` PRÉSENT (liste d'uids)    → allowlist explicite
// Le propriétaire est TOUJOURS lecteur (il ne peut pas se verrouiller dehors).
//
// Portée : les ressources natives de la suite (inventaires, plans) appliquent
// cette règle jusqu'à Firestore ; les ressources encore portées ailleurs
// (calendriers = MoPCal, finance = à venir) stockent l'accès DÉCLARÉ sur
// l'espace (`acces['cal:<id>']`, `acces.finance`), honoré par ces modules.

export function peutVoir(lecteurs, uid, ownerUid) {
  if (uid && ownerUid && uid === ownerUid) return true;
  if (!Array.isArray(lecteurs)) return true;   // absent → tout le monde
  return !!uid && lecteurs.includes(uid);
}

// Membres d'un espace, prêts pour l'UI : [{ uid, role, nom }].
export function membresDe(espace) {
  const m = espace?.membres || {};
  const noms = espace?.noms || {};
  const emails = espace?.emails || {};
  return Object.keys(m).map(uid => ({ uid, role: m[uid], nom: noms[uid] || '', email: emails[uid] || '' }));
}

export function estProprietaire(espace, uid) {
  return !!uid && (espace?.membres || {})[uid] === 'proprietaire';
}

// Bascule la visibilité d'un membre sur une ressource. Renvoie la NOUVELLE liste
// `lecteurs` (toujours explicite ; le propriétaire y est forcé). Partir d'une
// liste absente = « tout le monde » → on matérialise d'abord la liste complète.
export function basculerLecteur(lecteurs, tousUids, uid, ownerUid) {
  const base = Array.isArray(lecteurs) ? lecteurs : tousUids;
  const set = new Set(base);
  if (set.has(uid)) set.delete(uid); else set.add(uid);
  if (ownerUid) set.add(ownerUid);
  return tousUids.filter(u => set.has(u));   // ordonné, dédoublonné
}

// Accès déclaré d'une ressource « externe » (finance, calendrier) porté par
// l'espace. Même convention : absent = tout le monde.
export function lecteursDeclares(espace, cle) {
  const a = espace?.acces || {};
  return Array.isArray(a[cle]) ? a[cle] : null;
}
